var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overview-staff-root" },
    [
      _c("overview-topbar", {
        attrs: { dataTopBar: _vm.dataoverview.infosTopBar }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "overview-body container-big flex-row self-center wp-10"
        },
        [
          _c("div", { staticClass: "toggle-card-container" }, [
            _c("h3", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Informations")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "well relative" },
              _vm._l(_vm.dataoverview.infosLeftPanel.orderCards, function(
                card,
                indexCard
              ) {
                return _c(
                  "div",
                  { key: indexCard },
                  [
                    _c("toggle-nav", {
                      attrs: {
                        endpoint: _vm.dataoverview.infosLeftPanel.endpoint,
                        controller: _vm.dataoverview.infosLeftPanel.controller,
                        action: _vm.dataoverview.infosLeftPanel.action,
                        cardtype: indexCard,
                        linkedid: parseInt(
                          _vm.dataoverview.infosLeftPanel.linkedid
                        ),
                        linkedtype: _vm.dataoverview.infosLeftPanel.linkedtype
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "timeline-container flex-column flex pl-5",
              staticStyle: { "min-height": "700px" }
            },
            [
              _c("h3", { staticClass: "mb-3" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Activité")))
              ]),
              _vm._v(" "),
              _c("timeline", {
                attrs: {
                  forceTab: "activity",
                  linkedid: _vm.dataoverview.timeline.linkedid,
                  linkedtype: _vm.dataoverview.timeline.linkedtype,
                  overviewType: _vm.dataoverview.timeline.linkedtype
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }